<template>
  <div class="device-detail-fault-bd">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item style="float: right">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_device_detail_fault.bjbmgzdmsbr')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <!-- 日期过滤 -->
        <el-form-item style="float: right">
          <custom-date-picker
            style="width: 260px"
            v-model="timeSection"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :start-placeholder="$t('dms_device_detail_fault.sbkssj')"
            :end-placeholder="$t('dms_device_detail_fault.sbjssj')"
            :picker-options="pickerOptionDisAfter"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table :data="tableList" :column="tableColumn" @filter="filterChange" @sort="sortChange" :slots="['solutionMedia', 'disposalMethod']" max-height="600">
        <!-- 配置列 -->
        <template slot="solutionMedia" slot-scope="scope">
          <file-list-download :faultId="scope.row.faultId"></file-list-download>
        </template>
        <template slot="disposalMethod" slot-scope="scope">
          <el-button size="mini" type="text" @click="onFaultMore(scope.row)">{{ $t('Common.com_detail') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>

    <device-detail-fault-more v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onCurrentPage(1)"></device-detail-fault-more>
  </div>
</template>

<script>
import apis from '@/utils/apis';
// import fileListDownload from '@/components/deviceComponentDetailDrawer/fileListDownload.vue';
// import deviceDetailFaultMore from './device_detail_fault_more.vue';
import deviceDetailFaultMore from '@/pages/dms/components/device_detail_fault_more.vue';

export default {
  components: {
    // fileListDownload,
    deviceDetailFaultMore,
  },
  props: {
    deviceInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tableCode: 'device_detail_fault',
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        bodyNum: '',
        startDate: '',
        endDate: '',
      },

      tableList: [],
      totalRows: 0,
      timeSection: '',
      dialogVisible: false,
      dialogModel: {},
    };
  },
  mounted: function () {
    this.formSearch.bodyNum = this.deviceInfo.bodyNum;
    this.getTableColumn();
    this.getTableList();
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      this.formSearch.startDate = this.timeSection ? this.timeSection[0] : '';
      this.formSearch.endDate = this.timeSection ? this.timeSection[1] : '';
      this.$getJSON(apis.DeviceResumeDmsFaultPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 查看
    onFaultMore(row) {
      this.dialogModel.data = row;
      this.dialogVisible = true;
    },
    //
    // 数据导出
    exportTable: function () {
      this.$exportFlie(apis.DeviceResumeFaultExport, this.formSearch).then(() => {});
    },
  },
};
</script>

<style lang="scss">
.device-detail-fault-bd {
  padding: 8px 24px 44px 24px;
}
</style>
